import React from 'react';
import ContentArea from '@episerver/spa-core/Components/ContentArea';
import Page from '@episerver/spa-core/Page';
import Lobby from 'app/Components/Shared/Lobby';
import CellularLobbyPageData from 'Models/Content/CellularLobbyPageData';

export default class CellularLobbyPage extends Page<CellularLobbyPageData> {
  render() {
    const {
      data: {mainContentArea, headerCarousel},
      context,
    } = this.props;

    return (
      <div className='CellularLobbyPage'>
        <ContentArea noWrap data={headerCarousel} context={context} />
        <ContentArea noWrap data={mainContentArea} context={context} />
      </div>
    );
  }
}
